import { http, tryHttp } from '@pequity/shared/axios/http';
import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToApprovalsIfNoSettingsAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.appAccess.approvals.settings) {
    return next();
  } else {
    return next({ name: 'approvals' });
  }
};

export const redirectToApprovalsIfNoExportAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.appAccess.approvals.export) {
    return next();
  } else {
    return next({ name: 'approvals' });
  }
};

export const redirectToApprovalsIfNotDebugAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.appAccess.approvals.debug) {
    return next();
  } else {
    return next({ name: 'approvals' });
  }
};

export const redirectToHomeIfNoApprovalsAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  // Check if user has any approvals access (either add or settings access) or navigation access
  if (
    authStore.appAccess.approvals.add ||
    authStore.appAccess.approvals.settings ||
    authStore.appAccess.nav.approvals
  ) {
    return next();
  } else {
    return next({ name: 'home' });
  }
};

export const redirectToApprovalsIndexIfNotValidId: NavigationGuard = async (to, from, next) => {
  const id = Number(to.params.id);

  if (isNaN(id) || id <= 0) {
    return next({ name: 'approvals' });
  } else {
    return next();
  }
};

export const redirectToApprovalsIfInvalidApplicationId: NavigationGuard = async (to, from, next) => {
  const applicationId = Number(to.params.applicationId);

  if (isNaN(applicationId) || applicationId <= 0) {
    return next({ name: 'approvals' });
  } else {
    return next();
  }
};

export const redirectIfWritebackField: NavigationGuard = async (to, from, next) => {
  const fieldId = Number(to.params.id);

  // If invalid ID, let the other guard handle it
  if (isNaN(fieldId) || fieldId <= 0) {
    return next();
  }

  // Check if this field is currently used as a writeback field
  const { data, error } = await tryHttp(
    http.get<{ field_id: number | null }>('ats-integration/settings/current-writeback-field')
  );

  if (error) {
    // If API call fails, allow navigation to continue (fail open)
    return next();
  }

  const currentWritebackFieldId = data.field_id;

  if (currentWritebackFieldId === fieldId) {
    // Redirect to custom fields page with error message in query params
    return next({
      name: 'custom-fields',
      query: {
        error:
          'This field is being used in ATS settings for status writebacks and cannot be edited. Please remove it from ATS settings first.',
      },
    });
  } else {
    return next();
  }
};
